import React, { Fragment } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
  // Redirect
} from 'react-router-dom';
// libs
import 'url-search-params-polyfill';
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
import BookingRef from '../src/services/booking-ref';
const portrSDK = new PortrSDK();
// services
import BookingProductService from './services/booking-product.service';
import GATrackingService from './services/ga-tracking.service';
// components
import TrackingTimelineComponent from './components/tracking-timeline/tracking-timeline.component';
import BagWarningComponent from './components/bag-warning/bag-warning.component';
import CredentialsComponent from './containers/credentials/credentials.component';
import DeclarationLink from './components/declaration-link/declaration-link';
import PreSlotStatusComponent from './containers/pre-slot/pre-slot-status.component';
import DriverStatusComponent from './containers/driver/driver-status.component';
import InProgressStatusComponent from './containers/in-progress/in-progress-status.component';
import CompleteStatusComponent from './containers/complete/complete-status.component';
import LoadingScreenComponent from './components/loading-screen/loading-screen.component';
// Arrival
import PreSlotArrivalComponent from './containers/pre-slot-arrival/pre-slot-arrival';
// import ArrivalInProgressStatusComponent from './containers/arrival-in-progress/arrival-in-progress-status.component';
import ArrivalDriverStatusComponent from './components/arrival-in-progress-delivery/arrival-in-progress-delivery';
import ArrivalInProgressComponent from './containers/ccd-in-progress/ccd-in-progress.component';
import ArrivalBagsDeliveredComponent from './containers/ccd-bags-delivered/ccd-bags-delivered.component';
import ArrivalBagsProcessingComponent from './containers/ccd-bags-proccessing/ccd-bags-proccessing.component';
// import ArrivalBagDeliveredComponent from './components/arrival-bag-delivered/arrival-bag-delivered.component';
// import PreSlotCollectionComponent from './containers/pre-slot-collection/pre-slot-collection';
import PreSlotChecklistComponent from './containers/pre-slot-checklist/pre-slot-checklist';
// import ArrivalInProgressStatusComponent from './containers/arrival-in-progress/arrival-in-progress-status.component';
// models
import ITrackingDetails from './models/tracking-details.interface';
// globals
import {
  GET_DATETIME,
  GET_TRACKING_STATUS,
  GET_PASSENGER_RULES_COPY_DATA,
} from './globals';
// enums
import languages from './enum/language.enum';
// styles
const styles = require('./App.scss');
// package.json for version number
const configFile = require('../package.json');
// language file
import multiLang from './static-data/data';
import PreAcceptanceComponent from './components/pre-acceptance/pre-acceptance.component';
import NewHeaderComponent from './components/new-header/new-header.component';
import CcdBaggageUploadComponent from './containers/ccd-baggage-upload/ccd-baggage-upload';
const testResponse = require('./newbagscreen.json');

const API_PATH = process.env.REACT_APP_API_URL;
const BASE_API_PATH = process.env.REACT_APP_API_BASE_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
  'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY,
};
declare var locationPath: any;
// console.log('react inside', locationPath);

interface IState {
  status: number;
  statusString: string;
  productString: string;
  currentView: string;
  bookingNotFound: boolean;
  dataLoaded: boolean;
  trackingBookingDetails: ITrackingDetails;
  helpItems: Array<any>;
  userBookingRef: string;
  userEmail: string;
  hasDowngradedBag: boolean;
  language: string;
  languageCode: string;
  marketingAirlineCode: string;
  PreAcceptance: boolean;
  EDeclaration: boolean;
}
interface IComponentVarsInterface {
  queryParams: IQueryParams;
  apiKey: string;
  apiResponse: any;
  intervalValue: number;
  passengerRules: any;
}

interface IQueryParams {
  bookingRef: string;
  email: string;
  bookingJourneyReference: string;
  referrer: string;
  uploadBagImage?: string;
}

interface ITrackingDataRequest {
  bookingReference?: string;
  bookingJourneyReference?: string;
  bookingEmail?: string;
  referrer?: string;
  preCheckInImageUploadStatus?: number;
}

interface RuleItem {
  key: string;
  en: string;
  de: string;
  fr: string;
  it: string;
}

interface PassengerRuleInitialState {
  airlineCode: string;
  airlineName: string;
  email: RuleItem[];
  tracking_screen: RuleItem[];
  booking_funnel: RuleItem[];
}
/*

  SDS flow changes

  SDS - Outbound
  Pre-slot
  Driver
  In Progress
  Complete

  SDS - Inbound
  Pre-slot
  In Progress
  Driver
  Pre-slot
  Complete

  A2A
  Follow same path based on direction

*/

class PortrTrackingApp extends React.Component<any, IState> {

  private params = new URLSearchParams(window.location.search);
  private componentVars: IComponentVarsInterface = {
    queryParams: {
      bookingRef: null,
      email: null,
      bookingJourneyReference: null,
      referrer: null,
      uploadBagImage: null,
    },
    apiKey: null,
    apiResponse: null,
    intervalValue: null,
    passengerRules: null,
  };
  private timer = null;
  private product = null;

  public gaService = null;
  public bookingProductService = null;

  constructor(props: any) {
    super(props);
    this.state = {
      status: null,
      statusString: '',
      productString: '',
      helpItems: [],
      currentView: null,
      bookingNotFound: false,
      dataLoaded: false,
      trackingBookingDetails: null,
      marketingAirlineCode: null,
      PreAcceptance: false,
      EDeclaration: false,
      userBookingRef: null,
      userEmail: null,
      hasDowngradedBag: false,
      language: '',
      languageCode: 'en'
    };
  }

  componentDidMount() {
    localStorage.setItem('exponea__key', process.env.REACT_APP_EXPONEA_SUBSCRIPTION_KEY);
    this.getUrlParams();
    // console.log(window.location)
    // console.log(window.location.pathname)
  }

  private getUrlParams() {
    this.componentVars.queryParams.bookingRef = this.params.get('bookingref');
    this.componentVars.queryParams.email = this.params.get('email');
    this.componentVars.queryParams.bookingJourneyReference = this.params.get('bookingjourneyref');
    this.componentVars.queryParams.uploadBagImage = this.params.get('uploadbagimage') || this.params.get('uploadBagImage');
    this.componentVars.queryParams.referrer = this.params.get('referrer');
    // missing query params
    // show credentials screen
    if ((this.componentVars.queryParams.bookingRef === null || this.componentVars.queryParams.bookingRef === '') || (this.componentVars.queryParams.email === null || this.componentVars.queryParams.email === '')) {
      this.setState({ currentView: 'credentials' });
    } else {
      this.getTrackingData();
    }
    // if (locationPath === '/declaration') {
    //   this.customDeclaration();
    // }
  }

  private getTrackingData() {

    if (this.componentVars.apiKey === null) {
      portrSDK.getKeyWithHeader(
        API_PATH,
        GET_DATETIME,
        'get',
        header
      )
        .then((key: string) => {
          this.componentVars.apiKey = key;
          this.getData();
        })
        .catch((error: any) => {
          console.log(error);
        });
    } else {
      this.getData();
    }

  }

  getData() {

    const request: ITrackingDataRequest = {
      bookingEmail: this.componentVars.queryParams.email,
      bookingReference: this.componentVars.queryParams.bookingRef,
      bookingJourneyReference: this.componentVars.queryParams.bookingJourneyReference,
      referrer: this.componentVars.queryParams.referrer
    };

    const uploadBagImage =
      (this.componentVars.queryParams.uploadBagImage || '').toLowerCase() === 'true';

    if (uploadBagImage) {
      request.preCheckInImageUploadStatus = 1;
    }

    portrSDK.getTrackingDataWithHeader(
      API_PATH,
      GET_TRACKING_STATUS,
      'post',
      this.componentVars.apiKey,
      request,
      header
    )
      .then((res: any) => {
        console.log('API Response: ', res);
        console.log(testResponse);
        const data = res;

        this.componentVars.apiResponse = data;
        if (this.timer !== null) {
          clearInterval(this.timer);
        } else {
          this.setInitValues();
        }

        this.setViewState();
        this.setState({ bookingNotFound: false });
        if (data.customsDeclarationFlags !== null) {
          this.setState({ EDeclaration: true });
        }
        if (data.preAcceptance !== null) {
          this.setState({ PreAcceptance: true });
        }
        this.setDataInterval();
        this.getPassengerRules(data.marketingAirlineCode);
      })
      .catch((error: any) => {
        this.setState({ currentView: 'credentials' });
        this.setState({ bookingNotFound: true });
        this.componentVars.queryParams.bookingRef = null;
        this.componentVars.queryParams.email = null;
      });
  }

  private getTranslationMappedByKey(jsonArray: PassengerRuleInitialState[]) {
    const jsonData = {};

    jsonArray.forEach((airline: PassengerRuleInitialState) => {
      const airlineCode = airline.airlineCode;
      jsonData[airlineCode] = {};

      // only pick tracking screen rules
      airline.tracking_screen.forEach((rule) => {
        const messageKey = rule.key || rule.en;
        delete rule.key;

        jsonData[airlineCode][messageKey] = rule;
      });
    });

    console.log(
      'Converted object translations: ' + JSON.stringify(jsonData)
    );

    return jsonData;
  }

  getPassengerRules(airline) {
    const request = {
      airlineCode: airline
    };

    portrSDK
      .getTrackingDataWithHeader(
        BASE_API_PATH,
        GET_PASSENGER_RULES_COPY_DATA,
        'post',
        this.componentVars.apiKey,
        request,
        header
      )
      .then((data: any) => {
        const copyResponseData = this.getTranslationMappedByKey(
          data.dynamicContent
        );
        this.componentVars.passengerRules = copyResponseData;
        this.setState({ dataLoaded: true });
      })
      .catch((error: any) => {
        this.componentVars.passengerRules = null;
      });
  }

  private setDataInterval() {
    this.componentVars.intervalValue = this.state.status === 2 ? 60000 : 300000;

    this.timer = setInterval(() => {
      this.getData();
    }, this.componentVars.intervalValue);
  }

  private setInitValues() {
    this.setState({ status: this.componentVars.apiResponse.bookingStatus });
    this.setState({ userBookingRef: this.componentVars.queryParams.bookingRef });
    this.setState({ userEmail: this.componentVars.queryParams.email });
    document.title = 'Track your AirPortr booking ' + this.componentVars.queryParams.bookingRef;

    this.bookingProductService = new BookingProductService(this.componentVars.apiResponse.trackingBookingDetails, this.componentVars.apiResponse.collectionSlot);
    this.product = this.bookingProductService.returnProductDetails();

    this.setState({ productString: this.bookingProductService.returnProductString(this.product) });
    this.setState({ statusString: this.bookingProductService.returnStatusString(this.product, this.state.status) });

    this.gaService = new GATrackingService(this.state.productString, this.state.userBookingRef, this.state.statusString, null, null);
    this.gaService.sendPageView();
  }

  private setLanguage() {
    const code = this.state.trackingBookingDetails && this.state.trackingBookingDetails.languageCode || 0;
    this.handleLanguageChange(languages[code]);
  }

  handleLanguageChange(langCode: string) {
    const code = langCode === 'en' ? '' : `_${langCode}`;

    console.log(langCode, code);

    this.setState({
      languageCode: langCode,
      language: code
    })
  }
  private setViewState() {
    this.setState({ currentView: null });
    this.setState({ trackingBookingDetails: this.componentVars.apiResponse.trackingBookingDetails }, () => {
      this.setLanguage();
    });

    if (this.componentVars.apiResponse.processTrackingStatus !== null) {
      this.setState({ hasDowngradedBag: this.componentVars.apiResponse.processTrackingStatus.hasDowngradedBag });
    }

    this.setState({ status: this.componentVars.apiResponse.bookingStatus });
    this.setState({ statusString: this.bookingProductService.returnStatusString(this.product, this.componentVars.apiResponse.bookingStatus) });
    this.setState({ helpItems: this.componentVars.apiResponse.faq });
    this.setState({ marketingAirlineCode: this.componentVars.apiResponse.marketingAirlineCode });
  }

  private handleLogin(formData: { bookingReference: string; emailAddress: string }) {
    this.componentVars.queryParams.bookingRef = formData.bookingReference;
    this.componentVars.queryParams.email = formData.emailAddress;
    this.componentVars.queryParams.referrer = 'self';

    this.params.set('bookingref', formData.bookingReference);
    this.params.set('email', formData.emailAddress);
    this.params.set('referrer', 'self');
    const pageUrl = '?' + this.params.toString();
    if (locationPath === '/declaration') {
      window.history.pushState('', '', 'declaration' + pageUrl);
    } else {
      window.history.pushState('', '', pageUrl);
    }
    this.getTrackingData();
  }

  render() {
    const uploadBagImage = (this.componentVars.queryParams.uploadBagImage || '').toLowerCase() === 'true'
    const showLoader = () => {
      return <LoadingScreenComponent data={null}></LoadingScreenComponent>
    };

    const showComponent = (airlinePassengerRules, marketingAirlineCode, status, productType, journeyDirection) => {

      const airlineCode = marketingAirlineCode || '';
      const airlineName = this.componentVars.apiResponse?.flightDetails?.marketingAirlineName;
      // url contains uploadBagImage=true then show upload bag image component
      if (uploadBagImage) {
        return (
          <>
            <NewHeaderComponent
              languageCode={this.state.languageCode}
              handleLanguageChange={(val) => this.handleLanguageChange(val)}
            />
            <CcdBaggageUploadComponent
              multiLang={multiLang}
              language={this.state.language}
              getData={() => this.getData()}
              trackingData={this.componentVars.apiResponse}
              userBookingRef={this.state.userBookingRef}
              queryParams={this.componentVars.queryParams}
              userEmail={this.state.userEmail}
            />
          </>
        );
      }

      switch (status) {
        // in case of ABC initial
        case 1: {
          if (productType === 2 && journeyDirection === 2) {
            // return <PreSlotCollectionComponent multiLang={multiLang} language={this.state.language} trackingData={this.componentVars.apiResponse}></PreSlotCollectionComponent>;
            return (
              <ArrivalInProgressComponent
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
              />
            );
          } else {
            return (
              <PreSlotStatusComponent
                airlineCode={airlineCode}
                passengerRules={airlinePassengerRules}
                languageCode={this.state.languageCode}
                airlineName={airlineName}
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
                queryParams={this.componentVars.queryParams}
              ></PreSlotStatusComponent>
            );
          }
        }
        case 2: {
          if (productType === 2 && journeyDirection === 2) {
            return (
              <ArrivalDriverStatusComponent
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
                queryParams={this.componentVars.queryParams}
              ></ArrivalDriverStatusComponent>
            );
          } else {
            return (
              <DriverStatusComponent
                airlineName={airlineName}
                airlineCode={airlineCode}
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
                queryParams={this.componentVars.queryParams}
              ></DriverStatusComponent>
            );
          }
        }
        case 3: {
          if (productType === 2 && journeyDirection === 2) {
            // return <ArrivalInProgressStatusComponent multiLang={multiLang} language={this.state.language} trackingData={this.componentVars.apiResponse} queryParams={this.componentVars.queryParams}></ArrivalInProgressStatusComponent>;
            return (
              <ArrivalBagsProcessingComponent
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
              />
            );
          } else {
            return (
              <InProgressStatusComponent
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
              ></InProgressStatusComponent>
            );
          }
        }
        case 4: {
          if (productType === 2 && journeyDirection === 2) {
            // return <ArrivalBagDeliveredComponent multiLang={multiLang} language={this.state.language} trackingData={this.componentVars.apiResponse} queryParams={this.componentVars.queryParams}></ArrivalBagDeliveredComponent>;
            return (
              <ArrivalBagsDeliveredComponent
                multiLang={multiLang}
                language={this.state.language}
                trackingData={this.componentVars.apiResponse}
              />
            );
          } else {
            return (
              <BookingRef.Provider
                value={{ booking: this.state.userBookingRef }}
              >
                <CompleteStatusComponent
                  multiLang={multiLang}
                  language={this.state.language}
                  trackingData={this.componentVars.apiResponse}
                ></CompleteStatusComponent>
              </BookingRef.Provider>
            );
          }
        }
        // in case of CCD initial
        case 5: {
          if (
            this.componentVars.apiResponse.customsDeclarationFlags && this.componentVars.apiResponse.customsDeclarationFlags.isCustomsDeclarationSigned
          ) {
            return (
              <>
                <NewHeaderComponent
                  languageCode={this.state.languageCode}
                  handleLanguageChange={(val) => this.handleLanguageChange(val)}
                />
                <PreSlotChecklistComponent
                  multiLang={multiLang}
                  language={this.state.language}
                  getData={() => this.getData()}
                  trackingData={this.componentVars.apiResponse}
                  userBookingRef={this.state.userBookingRef}
                  queryParams={this.componentVars.queryParams}
                  userEmail={this.state.userEmail}
                ></PreSlotChecklistComponent>
                ;
              </>
            );
          }
          return (
            <>
              <NewHeaderComponent
                languageCode={this.state.languageCode}
                handleLanguageChange={(val) =>
                  this.handleLanguageChange(val)
                }
              />
              <PreSlotArrivalComponent
                multiLang={multiLang}
                language={this.state.language}
                getData={() => this.getData()}
                trackingData={this.componentVars.apiResponse}
                apiKey={this.componentVars.apiKey}
                queryParams={this.componentVars.queryParams}
              ></PreSlotArrivalComponent>
            </>
          );
        }
        default: {
          return (
            <CredentialsComponent
              multiLang={multiLang}
              language={this.state.language}
              languageCode={this.state.languageCode}
              handleLanguageChange={(val) => this.handleLanguageChange(val)}
              bookingNotFound={this.state.bookingNotFound}
              handleLogin={this.handleLogin.bind(this)}
            />
          );
        }
      }
    };

    let passengerRuleAirlineCode = '';
    let passengerRules = {};

    if (this.state.dataLoaded) {
      passengerRuleAirlineCode = this.state?.marketingAirlineCode || '';
      passengerRules =
        this.componentVars?.passengerRules[passengerRuleAirlineCode] ||
        {};
    }

    const preAcceptanceType = this.state.trackingBookingDetails?.preAcceptanceType;

    return (
      <div className={styles.portrTracking}>
        {this.state.currentView === 'credentials' ? (
          <CredentialsComponent
            multiLang={multiLang}
            language={this.state.language}
            languageCode={this.state.languageCode}
            handleLanguageChange={(val) => this.handleLanguageChange(val)}
            bookingNotFound={this.state.bookingNotFound}
            handleLogin={this.handleLogin.bind(this)}
          />
        ) : !this.state.dataLoaded || this.state.status === null ? (
          showLoader()
        ) : (
          <Fragment>
            <Router>
              <Switch>
                <Route path='/declaration'>
                  <DeclarationLink
                    multiLang={multiLang}
                    language={this.state.language}
                    languageCode={this.state.languageCode}
                    handleLanguageChange={(val) => this.handleLanguageChange(val)}
                    trackingData={this.componentVars.apiResponse}
                    userBookingRef={this.state.userBookingRef}
                    userEmail={this.state.userEmail}
                  ></DeclarationLink>
                </Route>
                <Route path='/'>
                  {this.state.PreAcceptance ? (
                    <PreAcceptanceComponent
                      isHubDrop={preAcceptanceType === 2}
                      passengerRules={passengerRules}
                      trackingData={this.componentVars.apiResponse}
                      language={this.state.language}
                      languageCode={this.state.languageCode}
                      handleLanguageChange={(val) => this.handleLanguageChange(val)}
                    />
                  ) : (
                    <>
                      {(!this.state.EDeclaration && !uploadBagImage) && (
                        <TrackingTimelineComponent
                          multiLang={multiLang}
                          language={this.state.language}
                          languageCode={this.state.languageCode}
                          handleLanguageChange={(val) => this.handleLanguageChange(val)}
                          status={this.state.status}
                          hasDowngradedBag={this.state.hasDowngradedBag}
                          handleRefreshData={this.getData.bind(this)}
                        ></TrackingTimelineComponent>
                      )}
                      {showComponent(
                        passengerRules,
                        this.state.marketingAirlineCode,
                        this.componentVars.apiResponse.bookingStatus,
                        this.state.trackingBookingDetails.addOnProductType[0],
                        this.state.trackingBookingDetails.journeyDirection
                      )}
                      {this.state.hasDowngradedBag ? (
                        <BagWarningComponent
                          multiLang={multiLang}
                          language={this.state.language}
                          userBookingRef={this.state.userBookingRef}
                          userEmail={this.state.userEmail}
                        ></BagWarningComponent>
                      ) : null}
                    </>
                  )}
                </Route>
              </Switch>
            </Router>
          </Fragment>
        )}
        <p className={styles.hidden}>Version: {configFile.version}</p>
        {/* <Redirect  to='/' /> */}
      </div>
    );
  }
}

export default PortrTrackingApp;



// WEBPACK FOOTER //
// ./src/App.tsx